const semanticClassNames = {
  inputContainer: 'checkbox__input-container',
} as const;

export default semanticClassNames;
